import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=233bd9fc&scoped=true&"
import script from "./Flow.vue?vue&type=script&lang=js&"
export * from "./Flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233bd9fc",
  null
  
)

export default component.exports